<template>
  <div>
    <!-- Dialog principal de pendências -->
    <v-dialog v-model="dialogVisible" fullscreen @update:model-value="handleDialogChange">
      <v-card class="d-flex flex-column" :height="mobile ? '100vh' : 'auto'">
        <!-- Header fixo com design melhorado -->
        <v-card-title class="bg-gradient-primary text-white sticky-top pa-0">

          <!-- Título Principal -->
          <div class="d-flex align-center w-100 pa-4 pb-2">
            <v-icon class="mr-3" size="large">mdi-alert-circle-outline</v-icon>
            <div class="flex-grow-1">
              <div class="text-h5 font-weight-bold">{{ titulo }}</div>
            </div>
            <div class="d-flex align-center justify-end flex-wrap gap-1 mr-2">
              <v-chip variant="flat" size="small" rounded="0" class="font-weight-medium metric-chip metric-chip-mov">
                <v-icon start size="small">mdi-swap-horizontal</v-icon>
                {{ totalPendenciasFiltradas }} de {{ totalPendenciasAtual }} movimentações
              </v-chip>
              <v-chip variant="flat" size="small" rounded="0" class="font-weight-medium metric-chip metric-chip-ordens">
                <v-icon start size="small">mdi-view-grid</v-icon>
                {{ resumoOrdensFiltradas.length }} ordem(ns)
              </v-chip>

              <v-chip variant="flat" size="small" rounded="0" class="font-weight-medium metric-chip metric-chip-pendencias">
                <v-icon start size="small">mdi-counter</v-icon>
                {{ totalPendenciasFiltradas }} pendência(s)
              </v-chip>
            </div>
            <v-btn icon variant="text" @click="fecharDialog" class="ml-2" size="large">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- ✅ ÁREA DE FILTROS ENCADEADOS -->
          <div class="pa-3 pt-0">
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="filtroCliente"
                  :items="opcoesCliente"
                  label="Cliente"
                  prepend-inner-icon="mdi-domain"
                  variant="outlined"
                  density="compact"
                  clearable
                  chips
                  closable-chips
                  hide-details
                  bg-color="rgba(255,255,255,0.1)"
                  color="white"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="filtroModelo"
                  :items="opcoesModelo"
                  label="Modelo"
                  prepend-inner-icon="mdi-tshirt-crew"
                  variant="outlined"
                  density="compact"
                  clearable
                  chips
                  closable-chips
                  hide-details
                  bg-color="rgba(255,255,255,0.1)"
                  color="white"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="filtroPedido"
                  :items="opcoesPedido"
                  label="Pedido SAP"
                  prepend-inner-icon="mdi-cart-outline"
                  variant="outlined"
                  density="compact"
                  clearable
                  chips
                  closable-chips
                  hide-details
                  bg-color="rgba(255,255,255,0.1)"
                  color="white"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="filtroSap"
                  :items="opcoesSap"
                  label="SAP / Ordem"
                  prepend-inner-icon="mdi-magnify"
                  variant="outlined"
                  density="compact"
                  clearable
                  chips
                  closable-chips
                  hide-details
                  bg-color="rgba(255,255,255,0.1)"
                  color="white"
                />
              </v-col>
            </v-row>

            <div class="d-flex align-center justify-end flex-wrap gap-1 mt-2 panel-info-right">
              <v-chip v-if="filtroCliente" color="white" text-color="grey-darken-3" variant="flat" size="small" rounded="0">
                <v-icon start size="small">mdi-domain</v-icon>
                {{ filtroCliente }}
              </v-chip>
              <v-chip v-if="filtroModelo" color="white" text-color="grey-darken-3" variant="flat" size="small" rounded="0">
                <v-icon start size="small">mdi-tshirt-crew</v-icon>
                {{ filtroModelo }}
              </v-chip>
              <v-chip v-if="filtroPedido" color="white" text-color="grey-darken-3" variant="flat" size="small" rounded="0">
                <v-icon start size="small">mdi-cart-outline</v-icon>
                {{ filtroPedido }}
              </v-chip>
              <v-chip v-if="filtroSap" color="white" text-color="grey-darken-3" variant="flat" size="small" rounded="0">
                <v-icon start size="small">mdi-clipboard-text</v-icon>
                {{ filtroSap }}
              </v-chip>

              <v-btn
                v-if="temFiltrosAtivos"
                color="white"
                variant="outlined"
                size="small"
                @click="limparFiltros"
                class="text-white border-white"
              >
                <v-icon start size="small">mdi-filter-remove</v-icon>
                Limpar
              </v-btn>

              <div v-if="totalPendenciasFiltradas === 0" class="mt-2 text-center">
                <v-chip color="orange" text-color="white" size="small">
                  <v-icon start size="small">mdi-alert</v-icon>
                  Nenhum resultado com os filtros selecionados
                </v-chip>
              </div>
            </div>
          </div>
        </v-card-title>

        <!-- TABELA DE ORDENS -->
        <v-card-text class="flex-grow-1 pa-3" style="overflow-y: auto;">

          <!-- Loading inicial -->
          <div v-if="loadingResumo" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            <div class="mt-3 text-body-1 text-grey">Carregando pendências...</div>
          </div>

          <div v-else-if="resumoOrdensFiltradas.length > 0">
            <v-table fixed-header density="comfortable" class="elevation-2 rounded-lg tabela-ordens" height="calc(100vh - 360px)">
              <thead>
                <tr class="bg-grey-lighten-3">
                  <th class="text-center font-weight-bold col-pedido">Pedido</th>
                  <th class="text-center font-weight-bold col-sap">SAP</th>
                  <th class="text-center font-weight-bold col-cliente" v-if="!mobile">Cliente</th>
                  <th class="text-center font-weight-bold col-modelo" v-if="!mobile">Modelo</th>
                  <th class="text-center font-weight-bold">Pend.</th>
                  <th class="text-center font-weight-bold col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ordem in resumoOrdensFiltradas" :key="ordem.id_ordem_cadastro" class="hover-row">
                  <td class="text-center col-pedido">
                    <v-chip size="small" class="chip-campo-grid chip-pedido">
                      {{ ordem.sap_pedido || '—' }}
                    </v-chip>
                  </td>
                  <td class="text-center col-sap">
                    <v-chip size="small" class="chip-campo-grid chip-sap">
                      {{ ordem.sap || '—' }}
                    </v-chip>
                  </td>
                  <td class="text-left col-cliente" v-if="!mobile">
                    <v-tooltip :text="ordem.cliente || '—'" location="top">
                      <template v-slot:activator="{ props }">
                        <v-chip v-bind="props" size="small" class="chip-campo-grid chip-cliente chip-truncate">
                          {{ ordem.cliente || '—' }}
                        </v-chip>
                      </template>
                    </v-tooltip>
                  </td>
                  <td class="text-center col-modelo" v-if="!mobile">
                    <v-chip size="small" class="chip-campo-grid chip-modelo chip-modelo-wrap">
                      {{ ordem.modelo || '—' }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-chip :color="ordem.total_pendencias > 5 ? 'red-darken-1' : 'blue-darken-1'" variant="flat" size="small" class="font-weight-bold">
                      <v-icon start size="small">mdi-alert-circle</v-icon>
                      {{ ordem.total_pendencias }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <div class="d-flex align-center justify-center gap-2">
                      <v-btn color="primary" size="small" variant="flat" rounded="lg"
                        :loading="carregandoDetalhe === ordem.id_ordem_cadastro"
                        @click="abrirDetalheOrdem(ordem)">
                        <v-icon start size="small">mdi-eye</v-icon>
                        {{ mobile ? '' : 'Ver' }}
                      </v-btn>
                      <v-btn color="success" size="small" variant="flat" rounded="lg"
                        :loading="carregandoDetalhe === ordem.id_ordem_cadastro || loadingAutorizacaoOrdem === String(ordem.id_ordem_cadastro)"
                        @click="processarTodasDaOrdem(ordem)">
                        <v-icon start size="small">mdi-check-all</v-icon>
                        {{ mobile ? '' : 'Proc.' }}
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>

          <!-- Mensagem quando não há pendências -->
          <div v-else class="text-center pa-8">
            <v-avatar size="120" color="blue-grey-lighten-4" class="mb-4">
              <v-icon size="60" color="blue-grey-lighten-1">
                {{ temFiltrosAtivos ? 'mdi-filter-remove' : 'mdi-clipboard-check-outline' }}
              </v-icon>
            </v-avatar>
            <h3 class="text-h5 mb-2 text-blue-grey-darken-1">
              {{ temFiltrosAtivos ? 'Nenhuma pendência encontrada com os filtros aplicados' : mensagemVazia }}
            </h3>
            <p class="text-body-1 text-grey">
              {{ temFiltrosAtivos ? 'Ajuste os filtros ou limpe para ver todas as pendências.' : descricaoVazia }}
            </p>
            <v-btn v-if="temFiltrosAtivos" color="primary" variant="outlined" class="mt-4" @click="limparFiltros">
              <v-icon start>mdi-filter-remove</v-icon>
              Limpar Filtro
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Restante dos dialogs mantém igual... -->
    <!-- Dialog de Confirmação Individual -->
    <v-dialog v-model="dialogConfirmarAutorizacao" max-width="600">
      <v-card>
        <v-card-title class="bg-warning text-white d-flex align-center">
          <v-icon class="mr-2">mdi-help-circle</v-icon>
          Confirmar Autorização Individual
        </v-card-title>

        <v-card-text class="pa-4">
          <p class="text-h6 mb-4">Deseja realmente autorizar esta movimentação?</p>

          <!-- ✅ CARD COM DADOS DA PENDÊNCIA MELHORADO -->
          <v-card v-if="pendenciaSelecionada" variant="outlined" class="mb-4">
            <v-card-text class="pa-4">
              <v-row dense>
                <!-- ID e Ordem -->
                <v-col cols="12" md="6">
                  <div class="info-group">
                    <div class="info-label">ID da Movimentação</div>
                    <v-chip color="blue-darken-1" variant="flat" size="small">
                      <v-icon start size="small">mdi-identifier</v-icon>
                      {{ pendenciaSelecionada.id }}
                    </v-chip>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="info-group">
                    <div class="info-label">Ordem SAP</div>
                    <v-chip color="orange-darken-1" variant="flat" size="small">
                      <v-icon start size="small">mdi-clipboard-text</v-icon>
                      {{ pendenciaSelecionada.ordem_producao?.id_ordem_sap || 'N/A' }}
                    </v-chip>
                  </div>
                </v-col>

                <!-- Cliente -->
                <v-col cols="12">
                  <div class="info-group">
                    <div class="info-label">Cliente</div>
                    <div class="info-value">
                      <v-icon color="primary" size="small" class="mr-2">mdi-domain</v-icon>
                      {{ pendenciaSelecionada.ordem_producao?.detalhes?.cliente?.nome || 'N/A' }}
                    </div>
                  </div>
                </v-col>

                <!-- Movimentação -->
                <v-col cols="12">
                  <div class="info-group">
                    <div class="info-label">Movimentação</div>
                    <div class="d-flex align-center">
                      <v-chip size="small" color="purple-darken-1" variant="outlined" class="mr-2">
                        {{ pendenciaSelecionada.setor_origem?.nome || 'N/A' }}
                      </v-chip>
                      <v-icon size="small" color="grey-darken-1">mdi-arrow-right-bold</v-icon>
                      <v-chip size="small" color="orange-darken-1" variant="outlined" class="ml-2">
                        {{ pendenciaSelecionada.setor_destino?.nome || 'N/A' }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>

                <!-- Item -->
                <v-col cols="12" md="4">
                  <div class="info-group">
                    <div class="info-label">Parte</div>
                    <div class="info-value font-weight-bold text-primary">
                      <v-icon color="primary" size="small" class="mr-2">mdi-puzzle</v-icon>
                      {{ pendenciaSelecionada.parte || 'N/A' }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="4">
                  <div class="info-group">
                    <div class="info-label">Tamanho</div>
                    <v-chip color="grey-darken-1" variant="outlined" size="small">
                      {{ pendenciaSelecionada.tamanho || 'N/A' }}
                    </v-chip>
                  </div>
                </v-col>

                <v-col cols="12" md="4">
                  <div class="info-group">
                    <div class="info-label">Quantidade</div>
                    <v-chip color="green-darken-1" variant="flat" size="small">
                      <v-icon start size="small">mdi-counter</v-icon>
                      {{ pendenciaSelecionada.quantidade || 0 }}
                    </v-chip>
                  </div>
                </v-col>

                <!-- Data -->
                <v-col cols="12" md="6">
                  <div class="info-group">
                    <div class="info-label">Data de Registro</div>
                    <v-chip color="indigo" variant="flat" size="small">
                      <v-icon start size="small">mdi-calendar</v-icon>
                      {{ formatarDataPendencia(pendenciaSelecionada.data_registro) }}
                    </v-chip>
                  </div>
                </v-col>

                <!-- Observação (se houver) -->
                <v-col cols="12" v-if="pendenciaSelecionada.observacao">
                  <div class="info-group">
                    <div class="info-label">Observação</div>
                    <div class="info-value">
                      <v-icon color="info" size="small" class="mr-2">mdi-note-text</v-icon>
                      {{ pendenciaSelecionada.observacao }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="outlined" @click="dialogConfirmarAutorizacao = false">
            <v-icon start>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="success" variant="flat" :loading="loadingAutorizacaoLocal !== null" @click="executarAutorizacao">
            <v-icon start>mdi-check-bold</v-icon>
            Confirmar Autorização
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação por Ordem -->
    <v-dialog v-model="dialogConfirmarAutorizacaoOrdem" max-width="700">
      <v-card>
        <v-card-title class="bg-success text-white d-flex align-center">
          <v-icon class="mr-2">mdi-check-all</v-icon>
          Confirmar Autorização em Lote
        </v-card-title>

        <v-card-text class="pa-4">
          <div class="text-h6 mb-4 d-flex align-center">
            <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
            Deseja autorizar TODAS as pendências desta ordem?
          </div>

          <v-card variant="outlined" class="mb-4" v-if="ordemSelecionadaParaAutorizar">
            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="text-caption text-grey">ORDEM SAP</div>
                  <div class="text-h6 font-weight-bold text-primary">{{ ordemSelecionadaParaAutorizar }}</div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-caption text-grey">TOTAL DE PENDÊNCIAS</div>
                  <div class="text-h6 font-weight-bold text-success">{{ pendenciasOrdemSelecionada.length }}</div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-caption text-grey">CLIENTE</div>
                  <div class="text-body-1">{{ pendenciasOrdemSelecionada[0]?.cliente || 'N/A' }}</div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-caption text-grey">MODELO</div>
                  <div class="text-body-1">{{ pendenciasOrdemSelecionada[0]?.modelo || 'N/A' }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-alert type="info" variant="tonal" class="mb-4">
            <div class="text-body-2">
              <strong>Atenção:</strong> Esta ação irá autorizar todas as {{ pendenciasOrdemSelecionada.length }}
              movimentações desta ordem de uma só vez.
            </div>
          </v-alert>

          <!-- Lista resumida das pendências -->
          <v-expansion-panels variant="accordion" class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-title>
                <v-icon class="mr-2">mdi-eye</v-icon>
                Ver detalhes das {{ pendenciasOrdemSelecionada.length }} pendências
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-list density="compact">
                  <v-list-item v-for="pendencia in pendenciasOrdemSelecionada" :key="pendencia.id" class="px-0">
                    <template v-slot:prepend>
                      <v-chip size="x-small" color="blue">{{ pendencia.id }}</v-chip>
                    </template>
                    <v-list-item-title class="text-body-2">
                      {{ pendencia.item?.parte || 'N/A' }} - {{ pendencia.item?.tamanho || 'N/A' }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ pendencia.movimentacao?.de || 'N/A' }} → {{ pendencia.movimentacao?.para || 'N/A' }}
                    </v-list-item-subtitle>
                    <template v-slot:append>
                      <v-chip size="x-small" color="green">{{ pendencia.item?.quantidade || 0 }}</v-chip>
                    </template>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="outlined" @click="dialogConfirmarAutorizacaoOrdem = false">
            <v-icon start>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="success" variant="flat" :loading="loadingAutorizacaoOrdem !== null" @click="executarAutorizacaoOrdem">
            <v-icon start>mdi-check-all</v-icon>
            Autorizar Todas ({{ pendenciasOrdemSelecionada.length }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ✅ DIALOG DE LOADING MELHORADO -->
    <v-dialog v-model="loadingDialog" persistent max-width="800">
      <v-card>
        <!-- Header do Loading -->
        <v-card-title class="bg-gradient-primary text-white pa-4">
          <v-icon class="mr-3">mdi-cog-sync</v-icon>
          <div class="flex-grow-1">
            <div class="text-h6 font-weight-bold">Processando Autorizações</div>
            <div class="text-body-2 opacity-90">
              Ordem SAP: {{ ordemSelecionadaParaAutorizar || 'Individual' }}
            </div>
          </div>
          <v-chip color="white" text-color="primary" class="font-weight-bold">
            {{ autorizacoesProcessadas }} / {{ totalAutorizacoes }}
          </v-chip>
        </v-card-title>

        <v-card-text class="pa-0">
          <!-- Progress Bar Geral -->
          <v-progress-linear :model-value="progressoGeral" height="8" color="success" bg-color="grey-lighten-3" striped
            class="mb-0"></v-progress-linear>

          <!-- Status Atual -->
          <div class="pa-4 bg-grey-lighten-5 border-b">
            <div class="d-flex align-center">
              <v-progress-circular v-if="statusAtual !== 'concluido'" indeterminate color="primary" size="24" width="3"
                class="mr-3"></v-progress-circular>
              <v-icon v-else color="success" class="mr-3">mdi-check-circle</v-icon>

              <div class="flex-grow-1">
                <div class="text-body-1 font-weight-bold">{{ mensagemStatusAtual }}</div>
                <div class="text-body-2 text-grey">{{ submensagemStatus }}</div>
              </div>
            </div>
          </div>

          <!-- Lista de Autorizações -->
          <div class="pa-4" style="max-height: 400px; overflow-y: auto;">
            <v-list density="compact" class="pa-0">
              <v-list-item v-for="(item, index) in listaAutorizacoes" :key="item.id" class="pa-3 mb-2 rounded"
                :class="getItemClass(item.status)">
                <template v-slot:prepend>
                  <!-- Ícone de Status -->
                  <v-avatar size="32" :color="getStatusColor(item.status)" class="mr-3">
                    <v-icon color="white" size="16">{{ getStatusIcon(item.status) }}</v-icon>
                  </v-avatar>
                </template>

                <div class="flex-grow-1">
                  <!-- Linha Principal -->
                  <div class="d-flex align-center mb-1">
                    <v-chip size="x-small" color="blue" class="mr-2">
                      ID: {{ item.id }}
                    </v-chip>
                    <div class="text-body-2 font-weight-bold flex-grow-1">
                      {{ item.parte }} - {{ item.tamanho }}
                    </div>
                    <v-chip size="x-small" :color="getStatusColor(item.status)" variant="flat">
                      {{ getStatusText(item.status) }}
                    </v-chip>
                  </div>

                  <!-- Linha Secundária -->
                  <div class="text-body-2 text-grey">
                    {{ item.movimentacao }} • Qtd: {{ item.quantidade }}
                    <span v-if="item.tempo" class="ml-2">• {{ item.tempo }}</span>
                  </div>

                  <!-- Mensagem de Erro (se houver) -->
                  <div v-if="item.status === 'erro' && item.mensagemErro" class="text-caption text-error mt-1">
                    <v-icon size="12" class="mr-1">mdi-alert-circle</v-icon>
                    {{ item.mensagemErro }}
                  </div>
                </div>

                <template v-slot:append>
                  <!-- Indicador de Progresso -->
                  <div class="text-center ml-3">
                    <v-progress-circular v-if="item.status === 'processando'" indeterminate color="primary" size="20"
                      width="2"></v-progress-circular>
                    <v-icon v-else-if="item.status === 'sucesso'" color="success" size="20">mdi-check-circle</v-icon>
                    <v-icon v-else-if="item.status === 'erro'" color="error" size="20">mdi-close-circle</v-icon>
                    <div class="text-caption text-grey mt-1">
                      #{{ index + 1 }}
                    </div>
                  </div>
                </template>
              </v-list-item>
            </v-list>
          </div>

          <!-- Resumo Final (quando concluído) -->
          <div v-if="statusAtual === 'concluido'" class="pa-4 bg-grey-lighten-5 border-t">
            <v-row dense>
              <v-col cols="4">
                <div class="text-center">
                  <v-icon color="success" size="24" class="mb-1">mdi-check-circle</v-icon>
                  <div class="text-h6 font-weight-bold text-success">{{ sucessos }}</div>
                  <div class="text-caption text-grey">Autorizadas</div>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="text-center">
                  <v-icon color="error" size="24" class="mb-1">mdi-close-circle</v-icon>
                  <div class="text-h6 font-weight-bold text-error">{{ erros }}</div>
                  <div class="text-caption text-grey">Falharam</div>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="text-center">
                  <v-icon color="primary" size="24" class="mb-1">mdi-clock</v-icon>
                  <div class="text-h6 font-weight-bold text-primary">{{ tempoTotal }}s</div>
                  <div class="text-caption text-grey">Tempo Total</div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <!-- Botões de Ação -->
        <v-card-actions class="pa-4" v-if="statusAtual === 'concluido'">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="fecharLoadingDialog">
            <v-icon start>mdi-check</v-icon>
            Concluído
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DE DETALHE DE PENDÊNCIAS POR ORDEM -->
    <v-dialog v-model="dialogDetalheOrdem" max-width="1100" scrollable>
      <v-card>
        <v-card-title class="bg-gradient-primary text-white pa-4">
          <div class="d-flex align-center w-100">
            <v-icon class="mr-3">mdi-clipboard-list-outline</v-icon>
            <div class="flex-grow-1">
              <div class="text-h6 font-weight-bold">Pendências da Ordem</div>
              <div class="text-body-2 opacity-90 d-flex align-center gap-2 mt-1">
                <v-chip color="rgba(255,255,255,0.3)" size="small" variant="flat">
                  <v-icon start size="small">mdi-clipboard-text</v-icon>
                  SAP: {{ ordemDetalheAtual }}
                </v-chip>
                <v-chip v-if="pendenciasDetalheAtual[0]?.id_ordem_cadastro" color="rgba(255,255,255,0.3)" size="small" variant="flat">
                  OP: {{ pendenciasDetalheAtual[0]?.id_ordem_cadastro }}
                </v-chip>
                <v-chip color="rgba(255,255,255,0.3)" size="small" variant="flat">
                  <v-icon start size="small">mdi-domain</v-icon>
                  {{ pendenciasDetalheAtual[0]?.cliente || '—' }}
                </v-chip>
              </div>
            </div>
            <div class="d-flex align-center gap-2">
              <v-chip color="white" text-color="primary" size="large" class="font-weight-bold mr-2">
                <v-icon start>mdi-counter</v-icon>
                {{ pendenciasDetalheAtual.length }} pendência(s)
              </v-chip>
              <v-btn icon variant="text" color="white" @click="dialogDetalheOrdem = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pa-0" style="max-height: 70vh; overflow-y: auto;">
          <!-- Tabela desktop -->
          <v-table v-if="!mobile" density="comfortable" class="elevation-0">
            <thead>
              <tr class="bg-grey-lighten-4">
                <th class="text-center font-weight-bold">Movimentação</th>
                <th class="text-center font-weight-bold">Item</th>
                <th class="text-center font-weight-bold">Qtd</th>
                <th class="text-center font-weight-bold">Data</th>
                <th class="text-center font-weight-bold">Observação</th>
                <th class="text-center font-weight-bold">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pendencia in pendenciasDetalheAtual" :key="pendencia.id" class="hover-row">
                <td class="text-center">
                  <div class="d-flex align-center justify-center">
                    <v-chip size="small" color="purple-darken-1" variant="outlined" class="mr-1">
                      {{ pendencia.movimentacao?.de || 'N/A' }}
                    </v-chip>
                    <v-icon size="small" class="mx-2" color="grey-darken-1">mdi-arrow-right-bold</v-icon>
                    <v-chip size="small" color="orange-darken-1" variant="outlined" class="ml-1">
                      {{ pendencia.movimentacao?.para || 'N/A' }}
                    </v-chip>
                  </div>
                </td>
                <td class="text-center">
                  <div class="font-weight-bold text-primary">{{ pendencia.item?.parte || 'N/A' }}</div>
                  <v-chip size="x-small" color="grey-darken-1" variant="outlined">
                    {{ pendencia.item?.tamanho || 'N/A' }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <v-chip color="green-darken-1" variant="flat" size="small">
                    <v-icon start size="small">mdi-counter</v-icon>
                    {{ pendencia.item?.quantidade || 0 }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <div class="text-body-2 font-weight-medium">{{ pendencia.tempo?.data_formatada || 'N/A' }}</div>
                  <v-chip size="x-small" :color="pendencia.tempo?.dias_pendente > 2 ? 'red-lighten-1' : 'grey-lighten-1'" variant="flat">
                    {{ pendencia.tempo?.dias_pendente || 0 }} dia(s)
                  </v-chip>
                </td>
                <td class="text-center" style="max-width:140px;">
                  <v-tooltip v-if="pendencia.observacao" :text="pendencia.observacao">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" size="small" color="grey-darken-1" variant="outlined" class="text-truncate">
                        <v-icon start size="small">mdi-note-text</v-icon>
                        {{ pendencia.observacao.substring(0, 10) }}...
                      </v-chip>
                    </template>
                  </v-tooltip>
                  <v-chip v-else size="small" color="grey-lighten-2" variant="outlined">
                    <v-icon size="small">mdi-note-off</v-icon>
                  </v-chip>
                </td>
                <td class="text-center">
                  <v-btn color="success" size="small" variant="flat" rounded="lg"
                    :loading="loadingAutorizacaoLocal === pendencia.id"
                    @click="confirmarAutorizacao(pendencia)">
                    <v-icon start>mdi-check-bold</v-icon>
                    Autorizar
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-table>

          <!-- Cards mobile -->
          <div v-else class="pa-2">
            <v-card v-for="pendencia in pendenciasDetalheAtual" :key="pendencia.id" class="mb-3 elevation-2" rounded="lg">
              <v-card-text class="pa-3">
                <div class="d-flex align-center mb-2">
                  <v-chip color="blue-darken-1" size="small" class="mr-2">ID: {{ pendencia.id }}</v-chip>
                  <v-chip v-if="pendencia.id_ordem_cadastro" color="teal-darken-1" variant="outlined" size="small" class="mr-2">
                    OP: {{ pendencia.id_ordem_cadastro }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-chip :color="pendencia.tempo?.dias_pendente > 2 ? 'red-lighten-1' : 'grey-lighten-1'" size="small">
                    {{ pendencia.tempo?.dias_pendente || 0 }} dia(s)
                  </v-chip>
                </div>
                <div class="mb-2">
                  <div class="text-caption text-grey mb-1">MOVIMENTAÇÃO</div>
                  <div class="d-flex align-center">
                    <v-chip size="small" color="purple-darken-1" variant="outlined" class="mr-2">{{ pendencia.movimentacao?.de || 'N/A' }}</v-chip>
                    <v-icon class="mx-1" size="small">mdi-arrow-right-bold</v-icon>
                    <v-chip size="small" color="orange-darken-1" variant="outlined" class="ml-2">{{ pendencia.movimentacao?.para || 'N/A' }}</v-chip>
                  </div>
                </div>
                <div class="mb-2 d-flex align-center">
                  <div class="flex-grow-1">
                    <div class="font-weight-bold">{{ pendencia.item?.parte || 'N/A' }}</div>
                    <div class="text-body-2 text-grey">Tam: {{ pendencia.item?.tamanho || 'N/A' }}</div>
                  </div>
                  <v-chip color="green-darken-1" size="small">{{ pendencia.item?.quantidade || 0 }} pcs</v-chip>
                </div>
                <v-btn color="success" block variant="flat" rounded="lg"
                  :loading="loadingAutorizacaoLocal === pendencia.id"
                  @click="confirmarAutorizacao(pendencia)">
                  <v-icon start>mdi-check-bold</v-icon>
                  Autorizar
                </v-btn>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4 bg-grey-lighten-5">
          <v-btn color="grey" variant="outlined" @click="dialogDetalheOrdem = false">
            <v-icon start>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" variant="flat" size="large" rounded="lg"
            :loading="loadingAutorizacaoOrdem === ordemDetalheAtual"
            @click="confirmarAutorizacaoOrdem(ordemDetalheAtual, pendenciasDetalheAtual)">
            <v-icon start>mdi-check-all</v-icon>
            Processar Todas ({{ pendenciasDetalheAtual.length }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { useDisplay } from 'vuetify'
import producaoService from '@/services/producaoService'

export default {
  name: 'PendenciasChefeDialog',

  props: {
    // Controle do dialog
    modelValue: {
      type: Boolean,
      default: false
    },

    // Dados das pendências
    pendencias: {
      type: Array,
      default: () => []
    },

    // Total de pendências
    totalPendencias: {
      type: Number,
      default: 0
    },

    // ID do chefe para autorização
    idChefe: {
      type: [Number, String],
      required: true
    },

    // Textos customizáveis
    titulo: {
      type: String,
      default: 'Pendências Não Autorizadas. (Versão 18-03-2026)'
    },

    mensagemVazia: {
      type: String,
      default: 'Nenhuma pendência encontrada'
    },

    descricaoVazia: {
      type: String,
      default: 'Não há movimentações pendentes para autorizar.'
    }
  },

  emits: ['update:modelValue', 'pendencia-autorizada', 'fechar'],

  data() {
    return {
      // ✅ FILTROS ENCADEADOS
      filtroCliente: null,
      filtroModelo: null,
      filtroPedido: null,
      filtroSap: null,
      loadingResumo: false,
      carregandoDetalhe: null,

      // ✅ PAGINAÇÃO INFINITA
      pagina: 1,
      itensPorPagina: 20,
      carregandoMais: false,
      temMais: false,
      todasPendencias: [], // Todas as pendências carregadas

      // Controle dos dialogs
      dialogConfirmarAutorizacao: false,
      dialogConfirmarAutorizacaoOrdem: false,
      loadingDialog: false,
      dialogDetalheOrdem: false,
      ordemDetalheAtual: null,
      pendenciasDetalheAtual: [],

      // Dados locais
      pendenciaSelecionada: null,
      loadingAutorizacaoLocal: null,
      loadingAutorizacaoOrdem: null,
      mensagemLoading: '',

      // Dados para autorização por ordem
      ordemSelecionadaParaAutorizar: null,
      pendenciasOrdemSelecionada: [],

      // Lista local de pendências (para manipulação)
      pendenciasLocais: [],

      // ✅ DADOS PARA O LOADING MELHORADO
      listaAutorizacoes: [],
      autorizacoesProcessadas: 0,
      totalAutorizacoes: 0,
      statusAtual: 'preparando',
      mensagemStatusAtual: '',
      submensagemStatus: '',
      sucessos: 0,
      erros: 0,
      tempoInicio: null,
      tempoTotal: 0,
    }
  },

  setup() {
    const { mobile } = useDisplay()
    return { mobile }
  },

  watch: {
    // Sincronizar pendências quando mudarem
    pendencias: {
      handler(novasPendencias) {
        this.pendenciasLocais = [...novasPendencias]
        this.inicializarPaginacaoInfinita()
      },
      immediate: true
    },

    // Limpar filtros quando dialog fechar
    modelValue: {
      handler(novoValor) {
        if (!novoValor) {
          this.$nextTick(() => {
            this.resetarComponente()
          })
        }
      },
      immediate: false
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },

    totalPendenciasAtual() {
      return this.pendenciasLocais.length
    },

    progressoGeral() {
      if (this.totalAutorizacoes === 0) return 0
      return (this.autorizacoesProcessadas / this.totalAutorizacoes) * 100
    },

    // ✅ AGRUPAR PENDÊNCIAS POR ORDEM SAP
    pendenciasAgrupadas() {
      if (!this.pendenciasLocais || this.pendenciasLocais.length === 0) {
        return {}
      }

      const agrupadas = {}

      this.pendenciasLocais.forEach(pendencia => {
        // ✅ ACESSO CORRETO AO SAP
        let ordemSap = 'Sem Ordem'

        // Tentar diferentes caminhos para encontrar o SAP
        if (pendencia.ordem_info?.sap) {
          ordemSap = String(pendencia.ordem_info.sap)
        } else if (pendencia.ordem_producao?.id_ordem_sap) {
          ordemSap = String(pendencia.ordem_producao.id_ordem_sap)
        } else if (pendencia.sap) {
          ordemSap = String(pendencia.sap)
        } else if (pendencia.ordem_sap) {
          ordemSap = String(pendencia.ordem_sap)
        } else if (pendencia.id_ordem_cadastro) {
          // ✅ ÚLTIMO RECURSO: Usar id_ordem_cadastro
          ordemSap = String(pendencia.id_ordem_cadastro)
        }

        if (!agrupadas[ordemSap]) {
          agrupadas[ordemSap] = []
        }

        agrupadas[ordemSap].push(pendencia)
      })

      return agrupadas
    },

    temFiltrosAtivos() {
      return Boolean(this.filtroCliente || this.filtroModelo || this.filtroPedido || this.filtroSap)
    },

    resumoOrdensBase() {
      return Object.entries(this.pendenciasAgrupadas).map(([ordemSap, pendencias]) => {
        const primeira = pendencias[0]
        const sapOriginal = primeira?.ordem_info?.sap ?? ordemSap
        const pedidoOriginal = primeira?.ordem_info?.sap_pedido ?? primeira?.sap_pedido
        return {
          id_ordem_cadastro: primeira?.id_ordem_cadastro ?? null,
          id_pedido: primeira?.id_pedido ?? null,
          sap_pedido: this.extrairNumeroCurto(pedidoOriginal, primeira?.id_pedido),
          sap: this.extrairNumeroCurto(sapOriginal, primeira?.id_ordem_cadastro),
          cliente: primeira?.cliente ?? '—',
          modelo: primeira?.modelo ?? '—',
          total_pendencias: pendencias.length,
          _pendencias: pendencias
        }
      })
    },

    opcoesCliente() {
      return this.extrairOpcoes('cliente')
    },

    opcoesModelo() {
      return this.extrairOpcoes('modelo')
    },

    opcoesPedido() {
      return this.extrairOpcoes('pedido')
    },

    opcoesSap() {
      return this.extrairOpcoes('sap')
    },

    resumoOrdensFiltradas() {
      const ordensFiltradas = this.aplicarFiltrosResumo(this.resumoOrdensBase)

      return ordensFiltradas.map((ordem) => ({
        ...ordem,
        _pendencias: this.ordenarPendenciasPorParteETamanho(ordem._pendencias)
      }))
    },

    pendenciasAgrupadasFiltradas() {
      const agrupadas = {}
      this.resumoOrdensFiltradas.forEach((ordem) => {
        agrupadas[ordem.sap] = ordem._pendencias
      })
      return agrupadas
    },

    totalPendenciasFiltradas() {
      return Object.values(this.pendenciasAgrupadasFiltradas)
        .reduce((total, pendencias) => total + pendencias.length, 0)
    }
  },

  methods: {
    handleDialogChange(value) {
      if (!value) {
        this.fecharDialog()
      }
    },

    fecharDialog() {
      // Reset completo do estado do componente
      this.resetarComponente()

      // Emitir eventos
      this.$emit('update:modelValue', false)
      this.$emit('fechar')

      console.log('✅ Componente fechado e filtros limpos')
    },

    // ✅ MÉTODO PARA RESET COMPLETO
    resetarComponente() {
      this.filtroCliente = null
      this.filtroModelo = null
      this.filtroPedido = null
      this.filtroSap = null
      this.pendenciaSelecionada = null
      this.loadingAutorizacaoLocal = null
      this.loadingAutorizacaoOrdem = null
      this.ordemSelecionadaParaAutorizar = null
      this.pendenciasOrdemSelecionada = []
      this.dialogConfirmarAutorizacao = false
      this.dialogConfirmarAutorizacaoOrdem = false
      this.loadingDialog = false
      this.mensagemLoading = ''

      // Reset dos dados de loading
      this.listaAutorizacoes = []
      this.autorizacoesProcessadas = 0
      this.totalAutorizacoes = 0
      this.statusAtual = 'preparando'
      this.mensagemStatusAtual = ''
      this.submensagemStatus = ''
      this.sucessos = 0
      this.erros = 0
      this.tempoInicio = null
      this.tempoTotal = 0

      // Reset dialog de detalhe
      this.dialogDetalheOrdem = false
      this.ordemDetalheAtual = null
      this.pendenciasDetalheAtual = []

      // ✅ Reset paginação infinita
      this.pagina = 1
      this.carregandoMais = false
      this.temMais = false
      this.todasPendencias = []
    },

    // ✅ INICIALIZAR PAGINAÇÃO INFINITA
    inicializarPaginacaoInfinita() {
      this.pagina = 1
      this.carregandoMais = false
      this.temMais = this.pendenciasLocais.length > this.itensPorPagina
      this.todasPendencias = [...this.pendenciasLocais]
    },

    // ✅ CARREGAR MAIS PENDÊNCIAS (ROLAGEM)
    carregarMaisPendencias() {
      if (this.carregandoMais || !this.temMais) return

      this.carregandoMais = true
      this.pagina++

      // Simular delay para UX
      setTimeout(() => {
        this.carregandoMais = false
        this.temMais = this.pagina * this.itensPorPagina < this.todasPendencias.length
      }, 300)
    },

    // ✅ PENDÊNCIAS VISÍVEIS (COM PAGINAÇÃO)
    pendenciasVisiveis() {
      const fim = this.pagina * this.itensPorPagina
      return this.todasPendencias.slice(0, fim)
    },

    // ✅ VERIFICAR ROLAGEM PARA CARREGAR MAIS (DESATIVADO)
    verificarRolagem(event) {
      // Desativado - agora mostra todas as pendências de uma vez
      return;
    },

    // ✅ ORDENAÇÃO POR PARTE E DEPOIS TAMANHO
    ordenarPendenciasPorParteETamanho(pendencias) {
      return pendencias.slice().sort((a, b) => {
        // 1º Critério: Ordenar por PARTE
        const parteA = String(a.item?.parte || a.parte || '').trim().toUpperCase()
        const parteB = String(b.item?.parte || b.parte || '').trim().toUpperCase()

        const comparacaoParte = parteA.localeCompare(parteB, 'pt-BR', {
          numeric: true,
          sensitivity: 'base'
        })

        // Se as partes são diferentes, usar essa ordenação
        if (comparacaoParte !== 0) {
          return comparacaoParte
        }

        // 2º Critério: Se partes iguais, ordenar por TAMANHO
        const tamanhoA = String(a.item?.tamanho || a.tamanho || '').trim()
        const tamanhoB = String(b.item?.tamanho || b.tamanho || '').trim()

        return this.compararTamanhosInteligente(tamanhoA, tamanhoB)
      })
    },

    // ✅ COMPARAÇÃO INTELIGENTE DE TAMANHOS
    compararTamanhosInteligente(tamanhoA, tamanhoB) {
      // Converter para string e limpar
      const a = String(tamanhoA).trim().toUpperCase()
      const b = String(tamanhoB).trim().toUpperCase()

      // Se ambos são números, comparar numericamente
      const numA = parseFloat(a)
      const numB = parseFloat(b)

      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB
      }

      // Se um é número e outro não, números vêm primeiro
      if (!isNaN(numA) && isNaN(numB)) return -1
      if (isNaN(numA) && !isNaN(numB)) return 1

      // Para strings, usar ordenação natural
      return a.localeCompare(b, 'pt-BR', {
        numeric: true,
        sensitivity: 'base'
      })
    },

    abrirDetalheOrdem(ordemOuSap, pendencias = null) {
      if (ordemOuSap && typeof ordemOuSap === 'object') {
        this.ordemDetalheAtual = ordemOuSap.id_ordem_cadastro ?? ordemOuSap.sap
        this.pendenciasDetalheAtual = ordemOuSap._pendencias ?? []
      } else {
        this.ordemDetalheAtual = ordemOuSap
        this.pendenciasDetalheAtual = pendencias ?? []
      }
      this.dialogDetalheOrdem = true
    },

    processarTodasDaOrdem(ordem) {
      this.confirmarAutorizacaoOrdem(
        ordem.id_ordem_cadastro ?? ordem.sap,
        ordem._pendencias ?? []
      )
    },

    extrairNumeroCurto(valor, fallback = null) {
      const texto = String(valor ?? '').trim()
      if (!texto) return fallback ? String(fallback) : '—'

      const numero = texto.match(/(\d+)$/)
      if (numero?.[1]) return numero[1]

      return fallback ? String(fallback) : texto
    },

    normalizarValorFiltro(valor) {
      return String(valor ?? '').trim().toLowerCase()
    },

    aplicarFiltrosResumo(resumoOrdens, campoIgnorado = null) {
      return resumoOrdens.filter((ordem) => {
        const cliente = this.normalizarValorFiltro(ordem.cliente)
        const modelo = this.normalizarValorFiltro(ordem.modelo)
        const pedido = this.normalizarValorFiltro(ordem.sap_pedido)
        const sap = this.normalizarValorFiltro(ordem.sap)
        const lanc = this.normalizarValorFiltro(ordem.id_ordem_cadastro)

        if (campoIgnorado !== 'cliente' && this.filtroCliente) {
          if (cliente !== this.normalizarValorFiltro(this.filtroCliente)) return false
        }

        if (campoIgnorado !== 'modelo' && this.filtroModelo) {
          if (modelo !== this.normalizarValorFiltro(this.filtroModelo)) return false
        }

        if (campoIgnorado !== 'pedido' && this.filtroPedido) {
          if (pedido !== this.normalizarValorFiltro(this.filtroPedido)) return false
        }

        if (campoIgnorado !== 'sap' && this.filtroSap) {
          const filtroSap = this.normalizarValorFiltro(this.filtroSap)
          if (sap !== filtroSap && lanc !== filtroSap) return false
        }

        return true
      })
    },

    extrairOpcoes(campo) {
      const ordens = this.aplicarFiltrosResumo(this.resumoOrdensBase, campo)
      const valores = new Set()

      ordens.forEach((ordem) => {
        let valor = ''

        if (campo === 'cliente') valor = ordem.cliente
        if (campo === 'modelo') valor = ordem.modelo
        if (campo === 'pedido') valor = ordem.sap_pedido
        if (campo === 'sap') valor = ordem.sap

        if (valor && valor !== '—') {
          valores.add(valor)
        }
      })

      return Array.from(valores).sort((a, b) =>
        String(a).localeCompare(String(b), 'pt-BR', {
          numeric: true,
          sensitivity: 'base'
        })
      )
    },

    limparFiltros() {
      this.filtroCliente = null
      this.filtroModelo = null
      this.filtroPedido = null
      this.filtroSap = null
    },

    // Abrir dialog de confirmação individual
    confirmarAutorizacao(pendencia) {
      this.pendenciaSelecionada = pendencia
      this.dialogConfirmarAutorizacao = true
    },

    // Confirmar autorização por ordem
    confirmarAutorizacaoOrdem(ordemSap, pendenciasOrdem) {
      this.ordemSelecionadaParaAutorizar = ordemSap
      this.pendenciasOrdemSelecionada = [...pendenciasOrdem]
      this.dialogConfirmarAutorizacaoOrdem = true
    },

    // ✅ PREPARAR LISTA DE AUTORIZAÇÕES
    prepararListaAutorizacoes(pendencias) {
      this.listaAutorizacoes = pendencias.map((pendencia, index) => ({
        id: pendencia.id,
        parte: pendencia.item?.parte || 'N/A',
        tamanho: pendencia.item?.tamanho || 'N/A',
        quantidade: pendencia.item?.quantidade || 0,
        movimentacao: `${pendencia.movimentacao?.de || 'N/A'} → ${pendencia.movimentacao?.para || 'N/A'}`,
        status: 'aguardando',
        mensagemErro: null,
        tempo: null
      }))

      this.totalAutorizacoes = pendencias.length
      this.autorizacoesProcessadas = 0
      this.sucessos = 0
      this.erros = 0
      this.tempoInicio = Date.now()
    },

    // ✅ ATUALIZAR STATUS DE UM ITEM
    atualizarStatusItem(id, status, mensagemErro = null) {
      const item = this.listaAutorizacoes.find(i => i.id === id)
      if (item) {
        item.status = status
        item.mensagemErro = mensagemErro

        if (status === 'sucesso' || status === 'erro') {
          this.autorizacoesProcessadas++
          item.tempo = `${((Date.now() - this.tempoInicio) / 1000).toFixed(1)}s`

          if (status === 'sucesso') {
            this.sucessos++
          } else {
            this.erros++
          }
        }
      }
    },

    // ✅ ATUALIZAR STATUS GERAL
    atualizarStatusGeral(status, mensagem, submensagem = '') {
      this.statusAtual = status
      this.mensagemStatusAtual = mensagem
      this.submensagemStatus = submensagem
    },

    // ✅ MÉTODOS PARA ESTILIZAÇÃO
    getItemClass(status) {
      switch (status) {
        case 'processando': return 'bg-blue-lighten-5 border-l-4 border-blue'
        case 'sucesso': return 'bg-green-lighten-5 border-l-4 border-green'
        case 'erro': return 'bg-red-lighten-5 border-l-4 border-red'
        default: return 'bg-grey-lighten-4'
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 'processando': return 'blue'
        case 'sucesso': return 'success'
        case 'erro': return 'error'
        default: return 'grey'
      }
    },

    getStatusIcon(status) {
      switch (status) {
        case 'processando': return 'mdi-cog-sync'
        case 'sucesso': return 'mdi-check'
        case 'erro': return 'mdi-close'
        default: return 'mdi-clock-outline'
      }
    },

    getStatusText(status) {
      switch (status) {
        case 'aguardando': return 'Aguardando'
        case 'processando': return 'Processando'
        case 'sucesso': return 'Autorizada'
        case 'erro': return 'Falhou'
        default: return 'Pendente'
      }
    },

    // ✅ FECHAR DIALOG DE LOADING
    fecharLoadingDialog() {
      this.loadingDialog = false
      this.tempoTotal = ((Date.now() - this.tempoInicio) / 1000).toFixed(1)

      // Fechar dialog principal se não há mais pendências
      if (this.pendenciasLocais.length === 0) {
        this.fecharDialog()
      }
    },

    // ✅ FORMATAR DATA PARA EXIBIÇÃO
    formatarDataPendencia(data) {
      if (!data) return 'N/A'

      try {
        const dataObj = new Date(data)
        return dataObj.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return 'Data inválida'
      }
    },

    // ✅ EXECUTAR AUTORIZAÇÃO INDIVIDUAL
    async executarAutorizacao() {
      if (!this.pendenciaSelecionada) return

      try {
        this.dialogConfirmarAutorizacao = false
        this.prepararListaAutorizacoes([this.pendenciaSelecionada])
        this.loadingDialog = true
        this.loadingAutorizacaoLocal = this.pendenciaSelecionada.id

        this.atualizarStatusGeral(
          'processando',
          'Autorizando movimentação individual...',
          `ID: ${this.pendenciaSelecionada.id} - ${this.pendenciaSelecionada.item?.parte || 'N/A'}`
        )

        this.atualizarStatusItem(this.pendenciaSelecionada.id, 'processando')

        const response = await producaoService.autorizarPendencia(
          this.pendenciaSelecionada.id,
          this.idChefe
        )

        console.log('Resposta da autorização:', response)

        this.atualizarStatusItem(this.pendenciaSelecionada.id, 'sucesso')

        this.pendenciasLocais = this.pendenciasLocais.filter(
          p => p.id !== this.pendenciaSelecionada.id
        )

        this.$emit('pendencia-autorizada', this.pendenciaSelecionada)

        this.atualizarStatusGeral(
          'concluido',
          'Autorização concluída com sucesso!',
          'Movimentação autorizada e processada'
        )

        console.log('Movimentação autorizada com sucesso!')

      } catch (error) {
        console.error('Erro ao autorizar pendência:', error)

        this.atualizarStatusItem(
          this.pendenciaSelecionada.id,
          'erro',
          error.message || 'Erro desconhecido'
        )

        this.atualizarStatusGeral(
          'concluido',
          'Erro na autorização',
          'Falha ao processar a movimentação'
        )

        console.log('Erro ao autorizar movimentação. Tente novamente.')
      } finally {
        this.loadingAutorizacaoLocal = null
        this.pendenciaSelecionada = null
      }
    },

    // ✅ EXECUTAR AUTORIZAÇÃO POR ORDEM (SUPER OTIMIZADO)
    async executarAutorizacaoOrdem() {
      if (!this.pendenciasOrdemSelecionada.length) return

      try {
        // Fechar dialog de confirmação
        this.dialogConfirmarAutorizacaoOrdem = false

        // ✅ PREPARAR INTERFACE DE LOADING
        this.prepararListaAutorizacoes(this.pendenciasOrdemSelecionada)
        this.loadingDialog = true
        this.loadingAutorizacaoOrdem = this.ordemSelecionadaParaAutorizar

        this.atualizarStatusGeral(
          'processando',
          'Autorizando pendências em lote...',
          `${this.pendenciasOrdemSelecionada.length} pendências sendo enviadas`
        )

        // ✅ COLETAR TODOS OS IDS
        const ids = this.pendenciasOrdemSelecionada.map(p => p.id)

        // ✅ MARCAR TODOS COMO PROCESSANDO NA UI
        ids.forEach(id => this.atualizarStatusItem(id, 'processando'))

        // ✅ CHAMADA BATCH ÚNICA (Reduz 50 requisições para 1)
        const response = await producaoService.autorizarPendenciasBatch(ids, this.idChefe)

        if (response.status === 'sucesso') {
          // ✅ SUCESSO: ATUALIZAR TODOS NA UI
          this.pendenciasOrdemSelecionada.forEach(pendencia => {
            this.atualizarStatusItem(pendencia.id, 'sucesso')

            // Remover da lista local imediatamente
            this.pendenciasLocais = this.pendenciasLocais.filter(p => p.id !== pendencia.id)

            // Emitir evento individual
            this.$emit('pendencia-autorizada', pendencia)
          })

          this.atualizarStatusGeral(
            'concluido',
            'Processo concluído com sucesso!',
            `${this.sucessos} movimentações autorizadas instantaneamente via Batch`
          )
        } else {
          throw new Error(response.mensagem || 'Falha na autorização em lote')
        }

      } catch (error) {
        console.error('Erro geral ao autorizar pendências da ordem:', error)

        // Se falhar o lote, marcar todos como erro para o usuário saber
        this.pendenciasOrdemSelecionada.forEach(p => {
          this.atualizarStatusItem(p.id, 'erro', error.message)
        })

        this.atualizarStatusGeral(
          'concluido',
          'Erro crítico no processo',
          'Falha ao processar autorizações em lote'
        )
      } finally {
        this.loadingAutorizacaoOrdem = null
        this.ordemSelecionadaParaAutorizar = null
        this.pendenciasOrdemSelecionada = []
      }
    }
  }
}
</script>

<style scoped>
/* ✅ GRADIENTE CINZA ELEGANTE */
.bg-gradient-dark {
  background: linear-gradient(135deg, #37474f 0%, #455a64 50%, #546e7a 100%);
  box-shadow: 0 4px 20px rgba(55, 71, 79, 0.3);
  position: relative;
  overflow: hidden;
}

.bg-gradient-dark::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #1976d2 0%, #1e88e5 50%, #2196f3 100%);
}

.hover-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
  transition: background-color 0.2s ease;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 10;
}

.border-b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.border-t {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

/* ✅ ESTILOS PARA O FILTRO DE TEXTO NO HEADER */
.filtro-text-header {
  border-radius: 12px;
}

.filtro-text-header .v-field {
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.filtro-text-header .v-field:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.filtro-text-header .v-field--focused {
  border-color: white;
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.filtro-text-header .v-field__input {
  color: white;
  font-weight: 500;
}

.filtro-text-header .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.filtro-text-header .v-icon {
  color: rgba(255, 255, 255, 0.8);
}

.filtro-text-header .v-field__clearable .v-icon {
  color: rgba(255, 255, 255, 0.6);
}

.filtro-text-header .v-field__clearable .v-icon:hover {
  color: white;
}

/* TABELA DE ORDENS PRINCIPAL */
.tabela-ordens thead tr th {
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 12px 16px;
  border-bottom: 2px solid rgba(0,0,0,0.08);
}

.tabela-ordens tbody tr td {
  padding: 10px 16px;
  vertical-align: middle;
}

.tabela-ordens tbody tr:nth-child(even) {
  background-color: rgba(0,0,0,0.015);
}

.tabela-ordens .col-lanc,
.tabela-ordens .col-pedido,
.tabela-ordens .col-sap {
  padding-left: 6px !important;
  padding-right: 6px !important;
  white-space: nowrap;
}

.chip-truncate {
  max-width: 150px;
  display: inline-flex !important;
  overflow: hidden;
}

.chip-truncate :deep(.v-chip__content) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.tabela-ordens .col-acoes {
  width: 110px;
  min-width: 110px;
  white-space: nowrap;
}

.tabela-ordens .col-cliente {
  min-width: 90px;
  max-width: 120px;
  width: 120px;
}

.tabela-ordens .col-modelo {
  min-width: 120px;
  max-width: 180px;
  width: 180px;
}

.chip-modelo-wrap {
  height: auto !important;
  min-height: 24px;
  max-width: 170px;
  white-space: normal !important;
  word-break: break-word;
}

.chip-modelo-wrap :deep(.v-chip__content) {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal !important;
  line-height: 1.3;
  text-align: center;
  color: #1a1a1a;
  font-weight: 600;
}

/* ✅ BOTÕES E CHIPS MELHORADOS */
.v-chip.font-weight-bold {
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.v-btn.border-white {
  border-color: rgba(255, 255, 255, 0.4) !important;
  transition: all 0.3s ease;
}

.v-btn.border-white:hover {
  border-color: white !important;
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

/* ✅ SCROLLBAR PERSONALIZADA */
.v-card-text::-webkit-scrollbar {
  width: 6px;
}

.v-card-text::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.v-card-text::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #37474f, #546e7a);
  border-radius: 3px;
}

.v-card-text::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #263238, #37474f);
}

/* ✅ ANIMAÇÕES SUAVES */
.gap-2 {
  gap: 8px;
}

.gap-1 {
  gap: 4px;
}

.v-chip,
.v-btn {
  transition: all 0.2s ease;
}

.v-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* ✅ CARDS COM SOMBRA MELHORADA */
.elevation-4 {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease;
}

.elevation-4:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

/* ✅ ESTILO PARA CHIPS DE STATUS */
.v-chip[color="success"] {
  background: linear-gradient(135deg, #4caf50, #66bb6a) !important;
}

.v-chip[color="primary"] {
  background: linear-gradient(135deg, #2196f3, #42a5f5) !important;
}

.v-chip[color="blue-darken-1"] {
  background: linear-gradient(135deg, #1976d2, #1e88e5) !important;
}

/* ✅ ESTILOS PARA O DIALOG DE LOADING */
.border-l-4 {
  border-left: 4px solid;
}

.border-blue {
  border-left-color: #2196f3;
}

.border-green {
  border-left-color: #4caf50;
}

.border-red {
  border-left-color: #f44336;
}

/* ✅ ANIMAÇÃO DE LOADING PERSONALIZADA */
.v-progress-circular {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

/* ✅ MELHORIAS PARA MOBILE */
@media (max-width: 768px) {
  .filtro-text-header .v-field {
    border-radius: 8px;
  }

  .gap-2 {
    gap: 4px;
  }

  .v-chip {
    font-size: 0.75rem;
  }
}

/* ✅ MELHORIAS ADICIONAIS */
.info-group {
  margin-bottom: 16px;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.info-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
}

/* ✅ BOTÕES ARREDONDADOS */
.v-btn.rounded-lg {
  border-radius: 12px !important;
}

/* ✅ ESPAÇAMENTO CONSISTENTE */
.v-card-actions .v-btn {
  min-width: 140px;
  height: 44px;
}

/* ✅ CHIP PROCESSAR COM GRADIENTE BONITO */
.chip-processar {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 50%, #81c784 100%) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.chip-processar:hover {
  background: linear-gradient(135deg, #43a047 0%, #5cb85c 50%, #7cb342 100%) !important;
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-2px);
}

.chip-processar:active {
  transform: translateY(0px);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

/* ✅ ESTILOS PARA DICAS E FEEDBACK */
.text-caption {
  opacity: 0.8;
}

/* ✅ ANIMAÇÃO PARA HIGHLIGHT */
@keyframes highlight {
  0% {
    background-color: rgba(255, 255, 255, 0.1);
  }

  50% {
    background-color: rgba(255, 255, 255, 0.3);
  }

  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.highlight-search {
  animation: highlight 2s ease-in-out;
}
</style>